import React from "react";
import { Button, ButtonProps, useDisclosure } from "@chakra-ui/react";

import { BaseModal } from "./BaseModal";

type IButtonModal = ButtonProps & {
  label: string;
  title: string;
};

export function ButtonModal({
  label,
  title,
  children,
  ...delegated
}: React.PropsWithChildren<IButtonModal>) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button onClick={onOpen} {...delegated}>
        {label}
      </Button>
      <BaseModal isOpen={isOpen} onClose={onClose} title={title}>
        {children}
      </BaseModal>
    </>
  );
}
